import classnames from "classnames";
import { Typography } from "neetoui";
import PropTypes from "prop-types";

const Block = ({ title, actionBlock, children, className = "" }) => (
  <div
    className="neeto-molecules-metadata__block neeto-ui-border-gray-200 mb-4 w-full border-b pb-4"
    data-testid="neeto-molecules-metadata-block"
  >
    {(title || actionBlock) && (
      <div className="mb-2 flex w-full items-center justify-between gap-2">
        {title && (
          <div className="flex w-60 items-center gap-2 break-all">
            <Typography
              className="neeto-ui-text-gray-700"
              data-testid="metadata-block-title"
              style="h5"
              textTransform="uppercase"
              weight="bold"
            >
              {title}
            </Typography>
          </div>
        )}
        {actionBlock && <div className="ms-auto">{actionBlock}</div>}
      </div>
    )}
    {!!children && (
      <div
        data-testid="metadata-card"
        className={classnames(
          "neeto-ui-bg-white neeto-molecules-metadata__card",
          className
        )}
      >
        {children}
      </div>
    )}
  </div>
);

Block.propTypes = {
  /**
   * To specify the content to be rendered on the right side of the title.
   */
  actionBlock: PropTypes.node,
  /**
   * To specify the title of the block.
   */
  title: PropTypes.string,
  /**
   * The content to be rendered inside the block.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * To specify external classNames as overrides to the `Block` component.
   */
  className: PropTypes.string,
};

export default Block;
